import React from 'react';
import PropTypes from 'prop-types';
import {CwFlyoutPointerPosition} from '../cwdialog/CwDialog';
import CwDialog from '../cwdialog/CwDialog';

const CwFlyout = (props) => {

  const setFlyoutPosition = () => {
    const windowHeight = window.innerHeight/2;
    const windowWidth = window.innerWidth/2;

    if (props.xCoord <= windowWidth && props.yCoord <= windowHeight) {
      return CwFlyoutPointerPosition.TOP_LEFT;
    }

    if (props.xCoord <= windowWidth && props.yCoord > windowHeight) {
      return CwFlyoutPointerPosition.BOTTOM_LEFT;
    }

    if (props.xCoord > windowWidth && props.yCoord <= windowHeight) {
      return CwFlyoutPointerPosition.TOP_RIGHT;
    }

    if (props.xCoord > windowWidth && props.yCoord > windowHeight) {
      return CwFlyoutPointerPosition.BOTTOM_RIGHT;
    }
  };
  
  return (
    <CwDialog {...props} data-cwid={props.cwId}
              flyoutPointerPosition={setFlyoutPosition()}/>
  );
};

CwFlyout.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Array of buttons aligned in the bottom right corner
   */
  buttons: PropTypes.arrayOf(PropTypes.element),
  /**
   * The primary header of the flyout
   */
  header: PropTypes.string.isRequired,
  /**
   * Specifies the height of the flyout
   */
  height: PropTypes.number,
  /**
   * The secondary header of the flyout
   */
  subHeader: PropTypes.string,
  /**
   * Specifies the width of the flyout
   */
  width: PropTypes.number,
  /**
   * Specifies the x coordinate of the flyout
   */
  x: PropTypes.number,
  /**
   * Specifies the y coordinate of the flyout
   */
  y: PropTypes.number,
  /**
   * Specifies the z-index of the flyout
   */
  zIndex: PropTypes.number,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: PropTypes.func
};

export default CwFlyout;



// WEBPACK FOOTER //
// ./src/components/cwflyout/CwFlyout.jsx